import app from "../app";

app.value('upgrades',[
    {
      id: 0,
      name: "Bonus Resources I",
      price: 1,
      enabled: true,
    },
    {
      id: 1,
      name: "Save Point",
      price: 3,
      enabled: false,
    },
    {
      id: 2,
      name: "Bonus Resources II",
      price: 5,
      enabled: false,
    },
    {
      id: 3,
      name: "Bonus Resources III",
      price: 20,
      enabled: false,
    },
    {
      id: 4,
      name: "Bonus Resources IV",
      price: 80,
      enabled: false,
    },
    {
      id: 5,
      name: "Bonus Resources V",
      price: 350,
      enabled: false,
    },
    {
      id: 6,
      name: "Bonus Resources VI",
      price: 1000,
      enabled: false,
    },
    {
      id: 7,
      name: "Bonus Resources VII",
      price: 4000,
      enabled: false,
    },
    {
      id: 8,
      name: "Bonus Resources VIII",
      price: 15000,
      enabled: false,
    },
    {
      id: 9,
      name: "Bonus Resources IX",
      price: 45000,
      enabled: false,
    },
    {
      id: 10,
      name: "Bonus Resources X",
      price: 100000,
      enabled: false,
    },
    {
      id: 11,
      name: "Potion Capacity",
      price: 100,
      enabled: false,
    },
    {
      id: 12,
      name: "Potion Capacity II",
      price: 500,
      enabled: false,
    },
    {
      id: 13,
      name: "Potion Capacity III",
      price: 2000,
      enabled: false,
    },
  ])